import React, { useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  Typography,
  IconButton,
  Box,
  Stack,
  InputAdornment,
  Alert,
  Fade,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

export default function ModalEstado({ empresaId, actualizarTabla }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = useState(false);
  const [estado, setEstado] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const API_GUARDAR = "https://demo.datachile.site/API/web/guardar_estado.php";

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setEstado("");
    setError("");
  };

  const guardarEstado = async (e) => {
    e.preventDefault();
    if (!estado) return setError("Debe ingresar estado");

    try {
      setLoading(true);
      await axios.post(API_GUARDAR, { estado });
      actualizarTabla();
      handleClose();
    } catch (err) {
      console.error(err);
      setError("Error al guardar estado");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{
          borderRadius: 2,
          px: 3,
          background: "linear-gradient(90deg, #1976d2, #42a5f5)",
        }}
      >
        Agregar Estado
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        fullScreen={isMobile}
        TransitionComponent={Fade}
        PaperProps={{ sx: { borderRadius: isMobile ? 0 : 4, display: "flex", flexDirection: "column" } }}
      >
        {/* HEADER */}
        <Box
          sx={{
            px: 4,
            py: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "linear-gradient(90deg, #1976d2, #42a5f5)",
            color: "white",
          }}
        >
          <Typography variant="h6">Nuevo Estado</Typography>
          <IconButton onClick={handleClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <form onSubmit={guardarEstado}>
          <DialogContent dividers sx={{ p: 4, overflowY: "auto" }}>
            {error && <Alert severity="error">{error}</Alert>}

            <TextField
              label="Estado"
              fullWidth
              value={estado}
              onChange={(e) => setEstado(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AssignmentTurnedInIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ mt: 2 }}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 4 }}>
              <Button onClick={handleClose} variant="outlined" fullWidth={isMobile}>
                Cancelar
              </Button>
              <Button
                type="submit"
                variant="contained"
                fullWidth={isMobile}
                disabled={loading}
                sx={{ background: "linear-gradient(90deg, #1976d2, #42a5f5)" }}
              >
                {loading ? "Guardando..." : "Guardar"}
              </Button>
            </Box>
          </DialogContent>
        </form>
      </Dialog>
    </>
  );
}